export default "__VITE_ASSET__Bz9OwS5C__"